import React from 'react';
import { Link } from 'react-router-dom';


const TermsOfUse = () => {

  return (
    <>
    <div className='background'></div>
    <div className="content-wrapper">
    <div className='container-terms'>
    <div className='alignment-left bg'>

    <h1 className='h1-terms'>Terms of Use</h1>

    <div>
    <h5 className='h5-terms'><b>1. Acceptance of Terms</b></h5>
    <p className="p-terms">
    By accessing or using <b>Outplan</b> ("Service"), you agree to be bound by these Terms of Use.
    If you do not agree, do not use the Service.
    </p>

    <h5 className='h5-terms'><b>2. Eligibility</b></h5>
    <p className="p-terms">
    You must be at least 18 years old or the age of majority in your jurisdiction to use this Service.
    By using the Service, you represent and warrant that you meet this requirement. If you are using 
    the Service on behalf of an organization, you represent that you have the authority to bind that 
    organization to these Terms.
    </p>

    <h5 className='h5-terms'><b>3. Account Registration</b></h5>
    <p className="p-terms">
    You agree to provide accurate information and maintain the security of your login credentials.
    You are responsible for all activities that occur under your account. Notify us immediately of any
    unauthorized use of your account or any other breach of security. We are not liable for any loss
    or damage arising from your failure to comply with this obligation.
    </p>

    <h5 className='h5-terms'><b>4. Subscription and Payments</b></h5>
    <p className="p-terms">
    Paid plans are billed on a monthly or yearly basis. You agree to our billing terms outlined <a 
    className="dash-underlined-href-terms" href="/plans">here</a>. 
    You may cancel your subscription at any time, but you will not receive a refund for any unused
    portion of your subscription. We reserve the right to change our subscription fees and payment
    methods at any time. If we do so, we will notify you in advance.
    </p>

    <h5 className='h5-terms'><b>5. User Conduct</b></h5>
    <p className="p-terms">
    You agree not to misuse the Service, including uploading harmful content or violating laws.
    You are responsible for your conduct while using the Service. We reserve the right to investigate
    and take appropriate action against anyone who violates these Terms or engages in harmful conduct.
    You agree not to use the Service for any illegal or unauthorized purpose. You agree to comply with
    all applicable laws, rules, and regulations in connection with your use of the Service.
    You agree not to engage in any conduct that restricts or inhibits anyone's use or enjoyment of the
    Service, or which, as determined by us, may harm <b>Outplan</b> or users of the Service or expose them
    to liability. You agree not to use the Service in any manner that could disable, overburden, damage,
    or impair the Service or interfere with any other party's use of the Service, including their ability
    to engage in real time activities through the Service. You agree not to use any robot, spider, or
    other automatic device, process, or means to access the Service for any purpose, including monitoring
    or copying any of the material on the Service. You agree not to use any manual process to monitor or
    copy any of the material on the Service or for any other unauthorized purpose without our prior
    written consent. You agree not to use any device, software, or routine that interferes with the
    proper working of the Service, or that takes any action that imposes an unreasonable or disproportionately
    large load on our infrastructure. You agree not to interfere with or attempt to interfere with the
    proper working of the Service or any activities conducted on the Service. You agree not to bypass any
    measures we may use to prevent or restrict access to the Service, or any portion of the Service.
    You agree not to use the Service for any purpose that is unlawful or prohibited by these Terms, or
    any other purpose not intended by us. You agree not to use the Service in any manner that could
    damage, disable, overburden, or impair the Service or interfere with any other party's use of the
    Service, including their ability to engage in real time activities through the Service. You agree
    not to attempt to gain unauthorized access to the Service, other accounts, computer systems, or
    networks connected to the Service, through hacking, password mining, or any other means. You agree
    not to obtain or attempt to obtain any materials or information through any means not intentionally
    made available through the Service. You agree not to use the Service in any manner that could
    damage, disable, overburden, or impair the Service or interfere with any other party's use of the
    Service, including their ability to engage in real time activities through the Service.
    </p>

    <h5 className='h5-terms'><b>6. Intellectual Property</b></h5>
    <p className="p-terms">
    All rights, title, and interest in the Service remain with <b>Outplan</b>. You receive a limited, 
    non-transferable license to use the Service.
    You may not copy, modify, distribute, or create derivative works based on the Service without our
    express written permission. You may not use any trademarks, service marks, or logos of <b>Outplan</b>
    without our express written permission. You may not use any meta tags or any other "hidden text"
    utilizing our name or trademarks without our express written consent. You may not use any of our
    trademarks or service marks in any manner that is likely to cause confusion among customers, or
    in any manner that disparages or discredits us. You may not use any of our trademarks or service
    marks in connection with any product or service that is not ours, in any manner that is likely to
    cause confusion among customers, or in any manner that disparages or discredits us.
    </p>

    <h5 className='h5-terms'><b>7. Termination</b></h5>
    <p className="p-terms">
    We reserve the right to suspend or terminate your access for violations of these Terms.
    We may terminate your access to the Service at any time, without notice, for any reason.
    Upon termination, your right to use the Service will immediately cease. If you wish to terminate
    your account, you may simply discontinue using the Service. All provisions of these Terms which
    by their nature should survive termination shall survive, including, without limitation,
    ownership provisions, warranty disclaimers, indemnity, and limitations of liability.
    </p>

    <h5 className='h5-terms'><b>8. Disclaimers</b></h5>
    <p className="p-terms">
    The Service is provided "as is." We disclaim warranties of any kind and limit liability to the fullest extent.
    We do not guarantee that the Service will be uninterrupted, secure, or error-free. We are not liable for
    any indirect, incidental, or consequential damages arising from your use of the Service.
    To the fullest extent permitted by law, we disclaim all warranties, express or implied, including
    implied warranties of merchantability, fitness for a particular purpose, and non-infringement.
    We do not warrant that the Service will meet your requirements, or that the operation of the Service
    will be uninterrupted or error-free. We do not warrant that the Service will be free from viruses
    or other harmful components. We do not warrant that the Service will be compatible with any hardware
    or software. We do not warrant that the Service will be available at any particular time or location.
    We do not warrant that the Service will be secure or that any data you provide will be protected.
    We do not warrant that the Service will be free from errors or defects.
    </p>

    <h5 className='h5-terms'><b>9. Privacy</b></h5>
    <p className="p-terms">
    Please review our Privacy Policy <a 
    className="dash-underlined-href-terms" href="/privacy">here</a>.
    </p>

    <h5 className='h5-terms'><b>10. Modifications</b></h5>
    <p className="p-terms">
    We may modify these Terms. Continued use means you accept the changes. We will notify you of
    significant changes. If you do not agree to the modified Terms, you must stop using the Service.
    We reserve the right to modify or discontinue the Service at any time, without notice.
    We may also impose limits on certain features or restrict your access to parts or all of the Service
    without notice or liability. We reserve the right to modify these Terms at any time, and your continued
    use of the Service following any changes will constitute your acceptance of such changes.
    We will notify you of any changes to these Terms by posting the new Terms on the Service. You are
    advised to review these Terms periodically for any changes. Changes to these Terms are effective
    when they are posted on this page. Your continued use of the Service after any changes to these Terms
    will constitute your acceptance of such changes. 
    </p>

    <h5 className='h5-terms'><b>11. Governing Law</b></h5>
    <p className="p-terms">
    These Terms are governed by the laws of European Union.
    </p>

    </div>
    </div>

    </div>

    <div className="footer-container">
    <Link to="/home" className="footer">Home</Link>
    <div className='vertical-line'></div>
    <Link to="/terms" className="footer">Terms</Link>
    <div className='vertical-line'></div>
    <Link to="/privacy" className="footer">Privacy</Link>
    </div>

    <div style={{paddingBottom: "1rem", paddingTop: "1rem", color: 'white'}}>
    <p className="copyright">&copy; 2025 Luminicent Design Oy. All rights reserved.</p>
    </div>

    </div>
    </>

  );
};

export default TermsOfUse;
